import FJConfig from './FJConfig';

export default [
    {
        id: 'None',
        text: 'None',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'none.jpg',
    },
    {
        id: 'black-bar',
        text: 'black-bar',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'black-bar/black-bar.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'black-bar/black-bar.json',
    },
    {
        id: 'white-bar',
        text: 'white-bar',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-bar/white-bar.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-bar/white-bar.json',
    },
    {
        id: 'border',
        text: 'border',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'border/border.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'border/border.json',
    },
    {
        id: 'highlight',
        text: 'highlight',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'highlight/highlight.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'highlight/highlight.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'highlight/highlight.webm',
    },
    {
        id: 'block',
        text: 'block',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'block/block.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'block/block.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'block/block.webm',
    },
    {
        id: 'translucent',
        text: 'translucent',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'translucent/translucent.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'translucent/translucent.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'translucent/translucent.webm',
    },
    {
        id: 'dark',
        text: 'dark',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'dark/dark.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'dark/dark.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'dark/dark.webm',
    },
    {
        id: 'fresh',
        text: 'fresh',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'fresh/fresh.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'fresh/fresh.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'fresh/fresh.webm',
    },
    {
        id: 'white-bar-highlight',
        text: 'white-bar-highlight',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-bar-highlight/white-bar-highlight.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-bar-highlight/white-bar-highlight.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-bar-highlight/white-bar-highlight.webm',
    },
    {
        id: 'bright',
        text: 'bright',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'bright/bright.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'bright/bright.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'bright/bright.webm',
    },
    {
        id: 'slant',
        text: 'slant',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'slant/slant.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'slant/slant.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'slant/slant.webm',
    },
    {
        id: 'shadowed-block',
        text: 'shadowed-block',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'shadowed-block/shadowed-block.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'shadowed-block/shadowed-block.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'shadowed-block/shadowed-block.webm',
    },
    {
        id: 'spotlight',
        text: 'spotlight',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'spotlight/spotlight.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'spotlight/spotlight.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'spotlight/spotlight.webm',
    },
    {
        id: 'white-border',
        text: 'white-border',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-border/white-border.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-border/white-border.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'white-border/white-border.webm',
    },
    {
        id: 'hollow',
        text: 'hollow',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'hollow/hollow.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'hollow/hollow.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'hollow/hollow.webm',
    },
    {
        id: 'neon',
        text: 'neon',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'neon/neon.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'neon/neon.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'neon/neon.webm',
    },
    {
        id: 'shadow',
        text: 'shadow',
        imgUrl: FJConfig.SUBTITLE_STYLE_PATH + 'shadow/shadow.jpg',
        jsonUrl: FJConfig.SUBTITLE_STYLE_PATH + 'shadow/shadow.json',
        videoUrl: FJConfig.SUBTITLE_STYLE_PATH + 'shadow/shadow.webm',
    },
];
